module.exports = __webpack_public_path__ + "static/media/BILDClinic.4cb88cb6.png";